/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import LandingPageEntry from 'bundles/coursera-plus-landing-page/editorTool/LandingPageEntry';
import type { ImageReference } from 'bundles/coursera-plus-landing-page/editorTool/contextHelper';
import { useFeaturesContext } from 'bundles/coursera-plus-landing-page/editorTool/contextHelper';

const IMAGE_SIZE = 200;

const styles = {
  imageContainer: () => css`
    display: inline-block;
    margin: 16px;
    border-color: #ddd;
    border-style: solid;
    border-width: 1px;
  `,
  image: () => css`
    width: ${IMAGE_SIZE}px;
    height: ${IMAGE_SIZE}px;
    margin-right: 16px;
  `,
};

const ImageDisplay: React.FC<{ imageRef: ImageReference }> = (props) => {
  const { imageRef } = props;
  return (
    <div css={styles.imageContainer}>
      <table>
        <tr>
          <td>
            <Imgix
              src={imageRef.url}
              maxWidth={IMAGE_SIZE}
              maxHeight={IMAGE_SIZE}
              css={styles.image}
              alt={Imgix.DECORATIVE}
            />
          </td>
          <td>
            {imageRef.pages.map((page) => (
              <LandingPageEntry key={page.sys.id} page={page} />
            ))}
          </td>
        </tr>
      </table>
    </div>
  );
};

const ImageList: React.FC<{}> = () => {
  const context = useFeaturesContext();
  if (!context) {
    return null;
  }

  return (
    <div>
      {context.images.map((imageRef) => (
        <ImageDisplay imageRef={imageRef} />
      ))}
    </div>
  );
};

export default ImageList;
